/* unplugin-vue-components disabled */import { render } from "./answer-tabs.vue?vue&type=template&id=3f67f619&scoped=true"
import script from "./answer-tabs.vue?vue&type=script&lang=js"
export * from "./answer-tabs.vue?vue&type=script&lang=js"

import "./answer-tabs.vue?vue&type=style&index=0&id=3f67f619&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f67f619"],['__file',"src/components/ai-chat/ai-assistant/answer-tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f67f619"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f67f619', __exports__)) {
    api.reload('3f67f619', __exports__)
  }
  
  module.hot.accept("./answer-tabs.vue?vue&type=template&id=3f67f619&scoped=true", () => {
    api.rerender('3f67f619', render)
  })

}


export default __exports__